import {
    getParsedSessionStorageItem,
    setSessionStorageItem,
} from '../services/storage/session';

import { parseStringToBoolean } from './parsers';

export const QUERY_PARAMETERS_SESSION_STORAGE_KEY = 'zhl-prequal-queryParams';

type QueryParams = Record<string, string | boolean>;

class PersistedQueryParametersManager {
    private store: QueryParams;

    constructor() {
        this.hydrateState();
    }

    parseQueryParameters(query: string | null): QueryParams {
        if (query) {
            const params: QueryParams = {};
            for (const [key, value] of new URLSearchParams(query).entries()) {
                const parsedValue = parseStringToBoolean(value);
                if (
                    typeof parsedValue === 'string' ||
                    typeof parsedValue === 'boolean'
                ) {
                    params[key] = parsedValue;
                }
            }
            return params;
        }
        return {};
    }

    private _getHashString(): string | null {
        return typeof window !== 'undefined' && window.location.hash
            ? window.location.hash.substring(1)
            : null;
    }

    private _getSearchString(): string | null {
        return typeof window !== 'undefined' && window.location.search
            ? window.location.search.substring(1)
            : null;
    }

    private _getPathName(): string | null {
        return typeof window !== 'undefined' && window.location.pathname
            ? window.location.pathname
            : null;
    }

    private _getQueryParams(): QueryParams {
        const paramsFromSessionStorage =
            getParsedSessionStorageItem<QueryParams>(
                QUERY_PARAMETERS_SESSION_STORAGE_KEY
            ) ?? {};
        const inboundParams = this.parseQueryParameters(
            this._getSearchString()
        );
        return {
            ...paramsFromSessionStorage,
            ...inboundParams,
        };
    }

    hydrateState(): void {
        const queryParams = this._getQueryParams();
        setSessionStorageItem(
            QUERY_PARAMETERS_SESSION_STORAGE_KEY,
            queryParams
        );
        this.store = queryParams;
    }

    getQueryParameters(): QueryParams {
        return { ...this.store };
    }
}

const queryParamsManager = new PersistedQueryParametersManager();
export default queryParamsManager;
